import { useMutation } from '@tanstack/react-query';
import { createUser as createUserService } from 'services/api/AccessManagerAPI';

export const useCreateUser = () => {
    const { mutateAsync: createUser, isPending } = useMutation({
        mutationFn: createUserService,
        retry: false,
    });

    return { createUser, isPending };
};
